import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/repeated-from/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_REPEATED_FROM]: ({ orderId }) => ({ orderId }),
});

export default directOrderRecurring;
